const platform = 'web';

export default platform;
